import { Component, OnInit, Input } from '@angular/core';
import { ITextblock } from '../../../core/interfaces/textblock.interface';

@Component({
  selector: 'aig-textblock',
  templateUrl: './textblock.component.html',
  styleUrls: ['./textblock.component.css'],
  standalone: true,
})
export class TextblockComponent implements OnInit {

  @Input() config: ITextblock = {
    status : "",
    icon : "",
    title : "",
    subtitle : ""
  };

  constructor() { }

  ngOnInit() {
  }

}
